import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule} from '@angular/forms';
import { UserService } from './user.service';
import { OnboardingFunnelComponent } from './admin/onboarding-funnel.component';
import { MaterialModule } from '../material/material.module';
import { LandingScreenComponent } from './unauthenticated/landing-screen-component';
import { UserDialogComponent } from './user-dialog.component';
import { UsersAdminComponent } from './admin/users-admin.component';
import { RegisteredComponent } from './unauthenticated/registered-component';
import { TicketDialogComponent } from './support/ticket-dialog.component';
import { TicketListComponent } from './support/ticket-list.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { TableComponent } from '../ui-components/table/table-component';
import { LinqCanvasModule } from '../canvas/linq.canvas.module';
import { RegisterDialogComponent } from './unauthenticated/register-dialog-component';

@NgModule({
  declarations: [
    UserDialogComponent,
    LandingScreenComponent,
    UsersAdminComponent,
    RegisteredComponent,
    TicketDialogComponent,
    TicketListComponent,
    RegisterDialogComponent
  ],
  exports: [
    UsersAdminComponent,
    TicketDialogComponent,
    TicketListComponent,
    RegisterDialogComponent
  ],
  imports: [
    MaterialModule,
    OnboardingFunnelComponent,
    FormsModule,
    GoogleSigninButtonModule,
    TableComponent,
    LinqCanvasModule,
    RouterModule
  ],
  providers: [
    UserService
  ]
})
export class UserModule { }